import { StepConnector } from "@mui/material";
import { useResponsiveValue } from "Hooks/useResponsiveValue";

export const CustomStepConnector = () => {
  const getResponsiveValue = useResponsiveValue();

  return (
    <StepConnector
      sx={{
        "& .MuiStepConnector-line": {
          borderColor: ({ palette }) => palette.grey[300],
          borderTopWidth: 2,
        },
        "&.MuiStepConnector-alternativeLabel": {
          top: getResponsiveValue([16, 24]),
          left: getResponsiveValue(["calc(-50% + 16px)", "calc(-50% + 24px)"]),
          right: getResponsiveValue(["calc(50% + 16px)", "calc(50% + 24px)"]),
        },
      }}
    />
  );
};
